import i18n from 'modules/core/lib/i18n'

import Item from 'modules/contracts/components/ContractDetails/LegalAndLabour/Item'

interface Props {
  hasForfaitJours: boolean
}

const ForfaitJours = ({ hasForfaitJours }: Props) => {
  const description = hasForfaitJours ? i18n.t('common.yes') : i18n.t('common.no')

  return (
    <Item
      title={i18n.t('contract_versions.legal_and_labour.france.forfait_jours')}
      description={description}
    />
  )
}

export default ForfaitJours
